import { render, staticRenderFns } from "./WorkersInShift.vue?vue&type=template&id=be2c12a4&"
import script from "./WorkersInShift.vue?vue&type=script&lang=js&"
export * from "./WorkersInShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports